import {
  Card,
  Checkbox,
  CrudMode,
  DataDisplay,
  formatBoolean,
  Grid,
  pn,
  Stack,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { CustomDataModelField, CustomDataModelFieldViewResource, ModelPropertyBase } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const BasicInfo = (props: {
  crudMode: CrudMode;
  customDataModelField: CustomDataModelField;
  setCustomDataModelField: (value: CustomDataModelField) => void;
  viewResource: CustomDataModelFieldViewResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  return (
    <Card>
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={setBreakpoints({ md: 2, xs: 12 })}>
          <DataDisplay label={properties.find((x) => x.propertyName === pn<CustomDataModelField>("id"))?.displayName}>
            {props.customDataModelField.id}
          </DataDisplay>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 6, xs: 12 })}>
          {props.crudMode === "view" && (
            <DataDisplay label={properties.find((x) => x.propertyName === pn<CustomDataModelField>("name"))?.displayName}>
              {props.customDataModelField.name}
            </DataDisplay>
          )}
          {props.crudMode === "edit" && (
            <Input
              
              modelProperty={properties.find((x) => x.propertyName === pn<CustomDataModelField>("name"))}
              errors={props.validationErrors[pn<CustomDataModelField>("name")]}
              value={props.customDataModelField.name}
              onChange={(e) =>
                props.setCustomDataModelField(
                  produce(props.customDataModelField, (draft) => {
                    draft.name = e.target.value;
                  })
                )
              }
            />
          )}
        </Grid>

        <Grid item xs={setBreakpoints({ md: 2, xs: 12 })}>
          {props.crudMode === "view" && (
            <DataDisplay label={properties.find((x) => x.propertyName === pn<CustomDataModelField>("isMandatory"))?.displayName}>
              {formatBoolean(props.customDataModelField.isMandatory)}
            </DataDisplay>
          )}
          {props.crudMode === "edit" && (
            <Stack height="100%" justifyContent={"center"}>
              <Checkbox
                label={properties.find((x) => x.propertyName === pn<CustomDataModelField>("isMandatory"))?.displayName}
                checked={props.customDataModelField.isMandatory}
                onChange={(e) =>
                  props.setCustomDataModelField(
                    produce(props.customDataModelField, (draft) => {
                      draft.isMandatory = e.target.checked;
                    })
                  )
                }
              />
            </Stack>
          )}
        </Grid>

        <Grid item xs={setBreakpoints({ md: 2, xs: 12 })}>
          {props.crudMode === "view" && (
            <DataDisplay label={properties.find((x) => x.propertyName === pn<CustomDataModelField>("isActive"))?.displayName}>
              {formatBoolean(props.customDataModelField.isActive)}
            </DataDisplay>
          )}
          {props.crudMode === "edit" && (
            <Stack height="100%" justifyContent={"center"}>
              <Checkbox
                label={properties.find((x) => x.propertyName === pn<CustomDataModelField>("isActive"))?.displayName}
                checked={props.customDataModelField.isActive}
                onChange={(e) =>
                  props.setCustomDataModelField(
                    produce(props.customDataModelField, (draft) => {
                      draft.isActive = e.target.checked;
                    })
                  )
                }
              />
            </Stack>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};
